import type { CSSProperties } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandS } from '@sorare/core/src/atoms/typography';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

const IconsWrapper = styled(Vertical).attrs({ center: true, gap: 2 })`
  width: 100%;
  flex: 1;
  min-height: 0;
`;
const BottomRow = styled(Horizontal).attrs({ gap: 2 })`
  width: 100%;
  min-height: 0;
  align-items: stretch;
  justify-content: space-around;
`;
const Wrapper = styled(Vertical).attrs({ center: true })`
  text-align: center;
  min-height: 0;
  & > img {
    min-height: 0;
    width: 100%;
    object-fit: contain;
  }
`;
const TicketsWrapper = styled(Wrapper)`
  max-width: 44%;
`;
const BottomItemWrapper = styled(Wrapper)`
  max-width: 33%;
`;

export const RewardIcons = () => {
  const {
    flags: { raffleRewardsAssets = { reward1: '', reward2: '', reward3: '' } },
  } = useFeatureFlags();

  return (
    <IconsWrapper>
      <TicketsWrapper>
        <img src={raffleRewardsAssets.reward1} alt="" />
        <BrandS>
          <FormattedMessage
            defaultMessage="<em>VIP</em> tickets"
            values={{
              em: chunks => (
                <BrandS
                  as="span"
                  className="text-gradient-color"
                  style={
                    {
                      '--text-gradient-color': 'var(--c-gradient-gold)',
                    } as CSSProperties
                  }
                >
                  {chunks}
                </BrandS>
              ),
            }}
          />
        </BrandS>
      </TicketsWrapper>
      <BottomRow>
        <BottomItemWrapper>
          <img src={raffleRewardsAssets.reward2} alt="" />
          <BrandS>
            <FormattedMessage
              defaultMessage="Jersey signed <em>Mbappé</em>"
              values={{
                em: chunks => (
                  <BrandS
                    as="span"
                    className="text-gradient-color"
                    style={
                      {
                        '--text-gradient-color':
                          'var(--c-gradient-conversionCreditBorder)',
                      } as CSSProperties
                    }
                  >
                    {chunks}
                  </BrandS>
                ),
              }}
            />
          </BrandS>
        </BottomItemWrapper>
        <BottomItemWrapper>
          <img src={raffleRewardsAssets.reward3} alt="" />
          <BrandS>
            <FormattedMessage defaultMessage="Mystery Jersey"></FormattedMessage>
          </BrandS>
        </BottomItemWrapper>
      </BottomRow>
    </IconsWrapper>
  );
};
